// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XgC7","newExpiryDate":"styles_newExpiryDate__1jipY","footer":"styles_footer__2DemR"};